import styled from "styled-components";

export const StyledSelection = styled.div<{
  isHighlight: boolean;
}>`
  position: absolute;
  background: ${({ isHighlight }) =>
    isHighlight ? "var(--Fill_Background_Light)" : "var(--Fill_Secondary)"};
  opacity: ${({ isHighlight }) => (isHighlight ? "0.2" : "0.6")};
  pointer-events: none;
`;
